import {
  Backdrop, Card, CardContent, CardHeader,
  CircularProgress, Container,
  Divider, Grid, Paper
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import Page from 'src/components/Page';
import axios from "src/utils/axios";
import { CreateWareHouseAddress, getUser } from 'src/utils/Common';
import LeftPaneUp from './LeftPaneUp';
import RightPaneUp from './RightPaneUp';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  }
}));


function Pass() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [dataPaslasma, setPaslasmaData] = useState([]);
  const [dataAcikFis, setAcikFisData] = useState([]);
  const [MALZEME_STOK_NO, setMALZEME_STOK_NO] = useState('');
  const user = getUser();

  useEffect(() => {
    CreateWareHouseAddress(user.ServiceShopId);
  }, []);
  const GetMalzemePaslasma = (MALZEME_STOK_NO) => {
    axios.get("GetMaterialPass/" + MALZEME_STOK_NO)
      .then(response => {
        // console.log(response);
        setPaslasmaData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }

  const GetOpenServicePaperMaterial = (MALZEME_STOK_NO) => {
    axios.get("GetOpenServicePaperMaterial/" + MALZEME_STOK_NO)
      .then(response => {
        // console.log(response);
        setAcikFisData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });
  }


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('');


  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="oasis Yönetimi Paslaşma" />
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
            {/* <Grid item xs={12} sm={3}>
                <Paper>
                  <LeftPaneUp setLoading={setLoading} GetMalzemePaslasma={GetMalzemePaslasma} />
                </Paper>
              </Grid> */}
              <Grid item xs={12} sm={12}>
                <RightPaneUp setLoading={setLoading} 
                dataPaslasma={dataPaslasma} setPaslasmaData={setPaslasmaData} MALZEME_STOK_NO={MALZEME_STOK_NO} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </Page>
  );
}

export default Pass;
